var pagination = {
	backwardText: "前のページ",
	forwardText: "次のページ",
	pageRangeText: "{current} / {total} ページ",
	itemsPerPageText: "ページあたりの項目数",
	itemRangeText: "{start}-{end} / {total} 個の項目",
	pageNumberText: "現在のページ"
};
var searchPlaceholder = "検索...";
var jaTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { jaTranslations as default, pagination, searchPlaceholder };
